/*
DAY BY DAY TOP 2 DESIGN / tasteful motion only
Native AW CONCEPT is deliberately excluded. Nothing is hidden before JS.
Works for dynamically populated Style File cards, supports reduced-motion.
*/
(function () {
  'use strict';

  function motionAllowed() {
    return typeof window.matchMedia === 'function' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  let observer;
  let gridObserver;

  function attach() {
    if (!document.querySelector('.dbdv3') || !document.querySelector('[data-aw-design-lab]')) return;
    if (!motionAllowed() || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('dbdv7-ready');

    if (observer) observer.disconnect();
    if (gridObserver) gridObserver.disconnect();

    observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('dbd-v7-revealed');
        instance.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.12 });

    const selectors = [
      '.dbdv3-brands__card',
      '.dbdv3-collection__visual',
      '.aw-style-file__card',
      '.aw-nail-file__card',
      '.aw-news__item'
    ].join(',');

    function observeUnseen(root) {
      if (!observer || !root) return;
      if (root.nodeType === 1 && root.matches && root.matches(selectors) &&
          !root.classList.contains('dbd-v7-revealed')) {
        observer.observe(root);
      }
      if (root.querySelectorAll) {
        root.querySelectorAll(selectors).forEach((element) => {
          if (!element.classList.contains('dbd-v7-revealed')) observer.observe(element);
        });
      }
    }

    const main = document.getElementById('MainContent');
    observeUnseen(main);

    const styleGrid = document.querySelector('[data-style-grid]');
    if (styleGrid && 'MutationObserver' in window) {
      gridObserver = new MutationObserver((records) => {
        records.forEach((record) => record.addedNodes.forEach(observeUnseen));
      });
      gridObserver.observe(styleGrid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach, { once: true });
  } else {
    attach();
  }
  document.addEventListener('shopify:section:load', attach);
})();
